import {initAccordions} from '$c3base/accordion.js';
import {initAnimations} from '$c3local/animation.js';

initAccordions();
initHamburger();
initMobileMenu();
initAnimations();
initMap();
initCounters();

function initHamburger() {
    /** @type {HTMLButtonElement} */
    const hamburger = document.querySelector('.page-header-hamburger');
    hamburger.addEventListener('click', () => {
        document.documentElement.classList.add('nav-open');
        window.scrollTo({top: 0, behavior: 'auto'});
    });

    /** @type {HTMLButtonElement} */
    const navClose = document.querySelector('.page-header-nav-close');
    navClose.addEventListener('click', () => {
        document.documentElement.classList.remove('nav-open');
    });
}

function initMobileMenu() {
    /** @type {NodeListOf<HTMLButtonElement>} */
    const openButtons = document.querySelectorAll('.menu-open');
    for (const button of openButtons) {
        button.addEventListener('click', () => {
            button.parentElement.classList.toggle('menu-item--is-open');

            for (const item of button.parentElement.parentElement.children) {
                if (item === button.parentElement) {
                    continue;
                }
                item.classList.remove('menu-item--is-open');
            }
        });
    }
}

function initMap() {
    const openAll = sessionStorage.getItem('mask_map') ?? false;

    document.querySelectorAll('.frame-type-mask-map').forEach(mapElement => {
        const showButton = mapElement.querySelector('.map-show');

        showButton.addEventListener('click', function() {
            const wrapperElement = this.parentElement;
            const mainElement = wrapperElement.parentElement;
            const src = this.getAttribute('data-src');

            wrapperElement.remove();

            const iframe = document.createElement('iframe');
            iframe.src = src;
            mainElement.appendChild(iframe);

            sessionStorage.setItem('mask_map', true);
        });

        if (openAll) {
            showButton.click();
        }
    });
}

function initCounters() {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !entry.target.dataset.counted) {
                animateCounter(entry.target);
                entry.target.dataset.counted = 'true';
            }
        });
    }, { threshold: 0.5 });

    document.querySelectorAll('.counter-number').forEach(counter => {
        observer.observe(counter);
    });
}

function animateCounter(element) {
    const target = parseInt(element.dataset.target);
    const duration = 4000;
    const startTime = performance.now();

    function formatNumber(num) {
        return num >= 10000
            ? Math.floor(num/1000) + '.' + String(num % 1000).padStart(3, '0')
            : num;
    }

    function update(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        const current = Math.floor(progress * target);
        element.textContent = `${formatNumber(current)}+`;

        if (progress < 1) {
            requestAnimationFrame(update);
        }
    }

    requestAnimationFrame(update);
}
